<template>
  <div>
    <v-row>
      <v-col :cols="12">
        <v-text-field
          label="Full Names [Required]"
          v-model="name"
          :rules="nameRules"
        ></v-text-field>
      </v-col>
      <v-col :cols="12">
        <v-text-field label="Phone [Required]" v-model="phone"></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          label="ID Number [Required]"
          v-model="idNumber"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field label="Email [Optional]" v-model="email"></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          label="Address [Optional]"
          v-model="address"
        ></v-text-field>
      </v-col>
      <v-col :cols="12">
        <v-text-field label="City [Optional]" v-model="city"></v-text-field>
      </v-col>
    </v-row>

    <v-btn rounded large block :color="getThemeColor" @click="addStaff()" dark>
      <v-icon left>mdi-check</v-icon>Add Staff
    </v-btn>
  </div>
</template>

<script>
import staffJs from "@/plugins/staff";

export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  data: () => ({
    name: null,
    idNumber: null,
    phone: null,
    email: null,
    city: null,
    address: null,
    nameRules: [(v) => !!v || "Field is required"],
  }),
  methods: {
    async addStaff() {
      if (!this.idNumber || !this.name || !this.phone) {
        alert("ID Number, Names And Phone  Fields Are Required!");
        return false;
      }
      this.$store.commit("setLoader", true);
      const staff = await staffJs.createStaff(
        this.name,
        this.idNumber,
        this.phone,
        this.email,
        this.city,
        this.address
      );

      this.$store.commit("setLoader", false);

      if (!staff.id) {
        this.$toast.error("Staff With This ID Number Already Exist!", {
          duration: 5000,
        });
      } else {
        this.$emit("staff-created", staff);
      }
    },
  },
};
</script>

<style></style>
